var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./oblidat.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-92fadf9c\"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./oblidat.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/oblidat/oblidat.vue
// module id = 41
// module chunks = 0